// extracted by mini-css-extract-plugin
export var productImage = "_ie-1";
export var viewLink = "_ie-2";
export var wishlistItem = "_ie-0";